// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Json = require("../../../shared/src/Json.bs.js");
var Curry = require("bs-platform/lib/js/curry.js");
var Apollo = require("../../../shared/src/bindings/Apollo.bs.js");
var Paging = require("../../../shared/src/Paging.bs.js");
var Relude_Set = require("relude/src/Relude_Set.bs.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var Relude_List = require("relude/src/Relude_List.bs.js");
var Relude_Array = require("relude/src/Relude_Array.bs.js");
var Relude_Float = require("relude/src/Relude_Float.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var WebTypes_Shift = require("../types/WebTypes_Shift.bs.js");
var CommonTypes_City = require("../../../shared/src/types/CommonTypes_City.bs.js");
var CommonTypes_Shift = require("../../../shared/src/types/CommonTypes_Shift.bs.js");
var CommonTypes_Rating = require("../../../shared/src/types/CommonTypes_Rating.bs.js");
var Paging_PageMarkers = require("../../../shared/src/Paging_PageMarkers.bs.js");
var CommonTypes_ZipCode = require("../../../shared/src/types/CommonTypes_ZipCode.bs.js");
var CommonTypes_ShiftType = require("../../../shared/src/types/CommonTypes_ShiftType.bs.js");
var CommonTypes_Worker_Id = require("../../../shared/src/types/worker/CommonTypes_Worker_Id.bs.js");
var CommonTypes_WorkerShift = require("../../../shared/src/types/CommonTypes_WorkerShift.bs.js");
var CommonTypes_LongPhoneNumber = require("../../../shared/src/types/CommonTypes_LongPhoneNumber.bs.js");
var CommonTypes_Shift_DressCode = require("../../../shared/src/types/CommonTypes_Shift_DressCode.bs.js");
var CommonTypes_Shift_RateStats = require("../../../shared/src/types/CommonTypes_Shift_RateStats.bs.js");
var CommonTypes_Business_Location = require("../../../shared/src/types/business/CommonTypes_Business_Location.bs.js");
var CommonTypes_ShiftType_Accessory = require("../../../shared/src/types/CommonTypes_ShiftType_Accessory.bs.js");
var CommonTypes_Shift_TipsPayoutType = require("../../../shared/src/types/CommonTypes_Shift_TipsPayoutType.bs.js");
var CommonTypes_PostAShift_AddressGeocode = require("../../../shared/src/types/CommonTypes_PostAShift_AddressGeocode.bs.js");
var CommonTypes_Business_RequestableWorker = require("../../../shared/src/types/business/CommonTypes_Business_RequestableWorker.bs.js");
var CommonTypes_Business_Location_ParkingCost = require("../../../shared/src/types/business/CommonTypes_Business_Location_ParkingCost.bs.js");

var Raw = {};

var query = "query   {\nshiftTypes(filter: {isEnabled: {equalTo: true}}, orderBy: [DISPLAY_ORDER_ASC])  {\nnodes  {\n...CommonTypes_ShiftType   \n}\n\n}\n\n}\n" + CommonTypes_ShiftType.query;

function parse(value) {
  var value$1 = value.shiftTypes;
  var tmp;
  if (value$1 == null) {
    tmp = undefined;
  } else {
    var value$2 = value$1.nodes;
    tmp = {
      nodes: value$2.map(function (value) {
            if (!(value == null)) {
              return CommonTypes_ShiftType.verifyArgsAndParse("CommonTypes_ShiftType", value);
            }
            
          })
    };
  }
  return {
          shiftTypes: tmp
        };
}

function serialize(value) {
  var value$1 = value.shiftTypes;
  var shiftTypes;
  if (value$1 !== undefined) {
    var value$2 = value$1.nodes;
    var nodes = value$2.map(function (value) {
          if (value !== undefined) {
            return CommonTypes_ShiftType.serialize(value);
          } else {
            return null;
          }
        });
    shiftTypes = {
      nodes: nodes
    };
  } else {
    shiftTypes = null;
  }
  return {
          shiftTypes: shiftTypes
        };
}

function serializeVariables(param) {
  
}

function makeVariables(param) {
  
}

function makeDefaultVariables(param) {
  
}

function variables(param) {
  return Json.Encode.object_(/* [] */0);
}

function decode(param) {
  var match = param.shiftTypes;
  if (match !== undefined) {
    return Relude_Option.pure(Relude_Array.mapOption((function (param) {
                      return Relude_Option.map(CommonTypes_ShiftType.tToR, param);
                    }), match.nodes));
  }
  
}

var Definition = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables,
  makeDefaultVariables: makeDefaultVariables,
  variables: variables,
  decode: decode
};

var include = Apollo.CreateQuery({
      Raw: Raw,
      query: query,
      variables: variables,
      parse: parse,
      decode: decode
    });

var GetShiftTypes_graphqlQueryAST = include.graphqlQueryAST;

var GetShiftTypes_query = include.query;

var GetShiftTypes_queryStoreError = include.queryStoreError;

var GetShiftTypes_queryResult = include.queryResult;

var GetShiftTypes_queryAsyncData = include.queryAsyncData;

var GetShiftTypes_queryAsyncDataStoreError = include.queryAsyncDataStoreError;

var GetShiftTypes_queryAsyncResult = include.queryAsyncResult;

var GetShiftTypes = {
  Definition: Definition,
  graphqlQueryAST: GetShiftTypes_graphqlQueryAST,
  query: GetShiftTypes_query,
  queryStoreError: GetShiftTypes_queryStoreError,
  queryResult: GetShiftTypes_queryResult,
  queryAsyncData: GetShiftTypes_queryAsyncData,
  queryAsyncDataStoreError: GetShiftTypes_queryAsyncDataStoreError,
  queryAsyncResult: GetShiftTypes_queryAsyncResult
};

var Raw$1 = {};

var query$1 = "query ($address: String!)  {\ngeocodeAddress(input: {address: $address})  {\n...CommonTypes_PostAShift_AddressGeocode   \n}\n\n}\n" + CommonTypes_PostAShift_AddressGeocode.query;

function parse$1(value) {
  var value$1 = value.geocodeAddress;
  return {
          geocodeAddress: !(value$1 == null) ? CommonTypes_PostAShift_AddressGeocode.verifyArgsAndParse("CommonTypes_PostAShift_AddressGeocode", value$1) : undefined
        };
}

function serialize$1(value) {
  var value$1 = value.geocodeAddress;
  var geocodeAddress = value$1 !== undefined ? CommonTypes_PostAShift_AddressGeocode.serialize(value$1) : null;
  return {
          geocodeAddress: geocodeAddress
        };
}

function serializeVariables$1(inp) {
  return {
          address: inp.address
        };
}

function makeVariables$1(address, param) {
  return {
          address: address
        };
}

function variables$1(address) {
  return Json.Encode.object_({
              hd: [
                "address",
                address
              ],
              tl: /* [] */0
            });
}

function decode$1(param) {
  return Curry._2(Relude_Option.flatMap, CommonTypes_PostAShift_AddressGeocode.tToR, param.geocodeAddress);
}

var Definition$1 = {
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1,
  makeVariables: makeVariables$1,
  variables: variables$1,
  decode: decode$1
};

var include$1 = Apollo.CreateQuery({
      Raw: Raw$1,
      query: query$1,
      variables: variables$1,
      parse: parse$1,
      decode: decode$1
    });

var GeocodeAddress_graphqlQueryAST = include$1.graphqlQueryAST;

var GeocodeAddress_query = include$1.query;

var GeocodeAddress_queryStoreError = include$1.queryStoreError;

var GeocodeAddress_queryResult = include$1.queryResult;

var GeocodeAddress_queryAsyncData = include$1.queryAsyncData;

var GeocodeAddress_queryAsyncDataStoreError = include$1.queryAsyncDataStoreError;

var GeocodeAddress_queryAsyncResult = include$1.queryAsyncResult;

var GeocodeAddress = {
  Definition: Definition$1,
  graphqlQueryAST: GeocodeAddress_graphqlQueryAST,
  query: GeocodeAddress_query,
  queryStoreError: GeocodeAddress_queryStoreError,
  queryResult: GeocodeAddress_queryResult,
  queryAsyncData: GeocodeAddress_queryAsyncData,
  queryAsyncDataStoreError: GeocodeAddress_queryAsyncDataStoreError,
  queryAsyncResult: GeocodeAddress_queryAsyncResult
};

var Raw$2 = {};

var query$2 = "mutation ($shiftId: BigInt!, $numOfWorkers: Int!, $arrivalInstructions: String!, $description: String!, $onsiteManagerName: String!, $onsiteManagerPhoneNumber: String!, $hourlyRateCents: Int!)  {\nbusinessUpdateShift(input: {shiftId: $shiftId, numOfWorkers: $numOfWorkers, arrivalInstructions: $arrivalInstructions, description: $description, onsiteManagerName: $onsiteManagerName, onsiteManagerPhoneNumber: $onsiteManagerPhoneNumber, hourlyRateCents: $hourlyRateCents})  {\nclientMutationId  \n}\n\n}\n";

function parse$2(value) {
  var value$1 = value.businessUpdateShift;
  var tmp;
  if (value$1 == null) {
    tmp = undefined;
  } else {
    var value$2 = value$1.clientMutationId;
    tmp = {
      clientMutationId: !(value$2 == null) ? value$2 : undefined
    };
  }
  return {
          businessUpdateShift: tmp
        };
}

function serialize$2(value) {
  var value$1 = value.businessUpdateShift;
  var businessUpdateShift;
  if (value$1 !== undefined) {
    var value$2 = value$1.clientMutationId;
    var clientMutationId = value$2 !== undefined ? value$2 : null;
    businessUpdateShift = {
      clientMutationId: clientMutationId
    };
  } else {
    businessUpdateShift = null;
  }
  return {
          businessUpdateShift: businessUpdateShift
        };
}

function serializeVariables$2(inp) {
  return {
          shiftId: inp.shiftId,
          numOfWorkers: inp.numOfWorkers,
          arrivalInstructions: inp.arrivalInstructions,
          description: inp.description,
          onsiteManagerName: inp.onsiteManagerName,
          onsiteManagerPhoneNumber: inp.onsiteManagerPhoneNumber,
          hourlyRateCents: inp.hourlyRateCents
        };
}

function makeVariables$2(shiftId, numOfWorkers, arrivalInstructions, description, onsiteManagerName, onsiteManagerPhoneNumber, hourlyRateCents, param) {
  return {
          shiftId: shiftId,
          numOfWorkers: numOfWorkers,
          arrivalInstructions: arrivalInstructions,
          description: description,
          onsiteManagerName: onsiteManagerName,
          onsiteManagerPhoneNumber: onsiteManagerPhoneNumber,
          hourlyRateCents: hourlyRateCents
        };
}

function variables$2(param) {
  var onsiteManager = param.onsiteManager;
  return Json.Encode.object_({
              hd: [
                "shiftId",
                Curry._1(CommonTypes_Shift.Id.encode, param.id)
              ],
              tl: {
                hd: [
                  "numOfWorkers",
                  param.numberOfWorkers
                ],
                tl: {
                  hd: [
                    "arrivalInstructions",
                    param.parkingInstructions
                  ],
                  tl: {
                    hd: [
                      "description",
                      param.description
                    ],
                    tl: {
                      hd: [
                        "onsiteManagerName",
                        onsiteManager.name
                      ],
                      tl: {
                        hd: [
                          "onsiteManagerPhoneNumber",
                          CommonTypes_LongPhoneNumber.encode(onsiteManager.phoneNumber)
                        ],
                        tl: {
                          hd: [
                            "hourlyRateCents",
                            param.hourlyRateCents
                          ],
                          tl: /* [] */0
                        }
                      }
                    }
                  }
                }
              }
            });
}

function decode$2(param) {
  return Relude_Option.pure(undefined);
}

var Definition$2 = {
  Raw: Raw$2,
  query: query$2,
  parse: parse$2,
  serialize: serialize$2,
  serializeVariables: serializeVariables$2,
  makeVariables: makeVariables$2,
  variables: variables$2,
  decode: decode$2
};

var include$2 = Apollo.CreateMutation({
      Raw: Raw$2,
      query: query$2,
      variables: variables$2,
      parse: parse$2,
      decode: decode$2
    });

var EditShift_graphqlMutationAST = include$2.graphqlMutationAST;

var EditShift_mutate = include$2.mutate;

var EditShift_mutateStoreError = include$2.mutateStoreError;

var EditShift_mutateResult = include$2.mutateResult;

var EditShift_mutateResultStore = include$2.mutateResultStore;

var EditShift_mutateAsyncData = include$2.mutateAsyncData;

var EditShift_mutateAsyncResult = include$2.mutateAsyncResult;

var EditShift_mutateAsycResultApolloError = include$2.mutateAsycResultApolloError;

var EditShift = {
  Definition: Definition$2,
  graphqlMutationAST: EditShift_graphqlMutationAST,
  mutate: EditShift_mutate,
  mutateStoreError: EditShift_mutateStoreError,
  mutateResult: EditShift_mutateResult,
  mutateResultStore: EditShift_mutateResultStore,
  mutateAsyncData: EditShift_mutateAsyncData,
  mutateAsyncResult: EditShift_mutateAsyncResult,
  mutateAsycResultApolloError: EditShift_mutateAsycResultApolloError
};

var Raw$3 = {};

var query$3 = "query ($shiftTypeId: BigInt!, $cityId: Int!, $shiftTimes: [ShiftTimeInput]!)  {\nshiftRateStats(cityId: $cityId, shiftTimes: $shiftTimes, shiftTypeId: $shiftTypeId)  {\nnodes  {\n...CommonTypes_Shift_RateStats   \n}\n\n}\n\n}\n" + CommonTypes_Shift_RateStats.query;

function parse$3(value) {
  var value$1 = value.shiftRateStats;
  var tmp;
  if (value$1 == null) {
    tmp = undefined;
  } else {
    var value$2 = value$1.nodes;
    tmp = {
      nodes: value$2.map(function (value) {
            if (!(value == null)) {
              return CommonTypes_Shift_RateStats.verifyArgsAndParse("CommonTypes_Shift_RateStats", value);
            }
            
          })
    };
  }
  return {
          shiftRateStats: tmp
        };
}

function serialize$3(value) {
  var value$1 = value.shiftRateStats;
  var shiftRateStats;
  if (value$1 !== undefined) {
    var value$2 = value$1.nodes;
    var nodes = value$2.map(function (value) {
          if (value !== undefined) {
            return CommonTypes_Shift_RateStats.serialize(value);
          } else {
            return null;
          }
        });
    shiftRateStats = {
      nodes: nodes
    };
  } else {
    shiftRateStats = null;
  }
  return {
          shiftRateStats: shiftRateStats
        };
}

function serializeInputObjectShiftTimeInput(inp) {
  var a = inp.startDatetime;
  var a$1 = inp.endDatetime;
  return {
          startDatetime: a !== undefined ? Caml_option.valFromOption(a) : undefined,
          endDatetime: a$1 !== undefined ? Caml_option.valFromOption(a$1) : undefined
        };
}

function serializeVariables$3(inp) {
  var a = inp.shiftTimes;
  return {
          shiftTypeId: inp.shiftTypeId,
          cityId: inp.cityId,
          shiftTimes: a.map(function (b) {
                if (b !== undefined) {
                  return serializeInputObjectShiftTimeInput(b);
                }
                
              })
        };
}

function makeVariables$3(shiftTypeId, cityId, shiftTimes, param) {
  return {
          shiftTypeId: shiftTypeId,
          cityId: cityId,
          shiftTimes: shiftTimes
        };
}

function makeInputObjectShiftTimeInput(startDatetime, endDatetime, param) {
  return {
          startDatetime: startDatetime,
          endDatetime: endDatetime
        };
}

function variables$3(param) {
  return Json.Encode.object_({
              hd: [
                "cityId",
                Curry._1(CommonTypes_City.Id.encode, param.cityId)
              ],
              tl: {
                hd: [
                  "shiftTimes",
                  Json.Encode.array(function (param) {
                          return Json.Encode.object_({
                                      hd: [
                                        "startDatetime",
                                        Json.Encode.date(param[0])
                                      ],
                                      tl: {
                                        hd: [
                                          "endDatetime",
                                          Json.Encode.date(param[1])
                                        ],
                                        tl: /* [] */0
                                      }
                                    });
                        })([[
                          param.startDatetime,
                          param.endDatetime
                        ]])
                ],
                tl: {
                  hd: [
                    "shiftTypeId",
                    Curry._1(CommonTypes_ShiftType.Id.encode, param.shiftTypeId)
                  ],
                  tl: /* [] */0
                }
              }
            });
}

function decode$3(param) {
  var match = param.shiftRateStats;
  if (match !== undefined) {
    return Curry._1(CommonTypes_Shift_RateStats.maxMinimumRateOfArray, Relude_Array.mapOption(Curry._1(Relude_Option.flatMap, CommonTypes_Shift_RateStats.tToR), match.nodes));
  }
  
}

var Definition$3 = {
  Raw: Raw$3,
  query: query$3,
  parse: parse$3,
  serialize: serialize$3,
  serializeVariables: serializeVariables$3,
  serializeInputObjectShiftTimeInput: serializeInputObjectShiftTimeInput,
  makeVariables: makeVariables$3,
  makeInputObjectShiftTimeInput: makeInputObjectShiftTimeInput,
  variables: variables$3,
  decode: decode$3
};

var include$3 = Apollo.CreateQuery({
      Raw: Raw$3,
      query: query$3,
      variables: variables$3,
      parse: parse$3,
      decode: decode$3
    });

var GetShiftRateStats_graphqlQueryAST = include$3.graphqlQueryAST;

var GetShiftRateStats_query = include$3.query;

var GetShiftRateStats_queryStoreError = include$3.queryStoreError;

var GetShiftRateStats_queryResult = include$3.queryResult;

var GetShiftRateStats_queryAsyncData = include$3.queryAsyncData;

var GetShiftRateStats_queryAsyncDataStoreError = include$3.queryAsyncDataStoreError;

var GetShiftRateStats_queryAsyncResult = include$3.queryAsyncResult;

var GetShiftRateStats = {
  Definition: Definition$3,
  graphqlQueryAST: GetShiftRateStats_graphqlQueryAST,
  query: GetShiftRateStats_query,
  queryStoreError: GetShiftRateStats_queryStoreError,
  queryResult: GetShiftRateStats_queryResult,
  queryAsyncData: GetShiftRateStats_queryAsyncData,
  queryAsyncDataStoreError: GetShiftRateStats_queryAsyncDataStoreError,
  queryAsyncResult: GetShiftRateStats_queryAsyncResult
};

var Raw$4 = {};

var query$4 = "mutation commentOnShift($shiftId: BigInt!, $comment: String!)  {\nupdateShiftById(input: {patch: {comment: $comment}, id: $shiftId})  {\nshift  {\n...WebTypes_Shift   \n}\n\n}\n\n}\n" + WebTypes_Shift.query;

function parse$4(value) {
  var value$1 = value.updateShiftById;
  var tmp;
  if (value$1 == null) {
    tmp = undefined;
  } else {
    var value$2 = value$1.shift;
    tmp = {
      shift: !(value$2 == null) ? WebTypes_Shift.verifyArgsAndParse("WebTypes_Shift", value$2) : undefined
    };
  }
  return {
          updateShiftById: tmp
        };
}

function serialize$4(value) {
  var value$1 = value.updateShiftById;
  var updateShiftById;
  if (value$1 !== undefined) {
    var value$2 = value$1.shift;
    var shift = value$2 !== undefined ? WebTypes_Shift.serialize(value$2) : null;
    updateShiftById = {
      shift: shift
    };
  } else {
    updateShiftById = null;
  }
  return {
          updateShiftById: updateShiftById
        };
}

function serializeVariables$4(inp) {
  return {
          shiftId: inp.shiftId,
          comment: inp.comment
        };
}

function makeVariables$4(shiftId, comment, param) {
  return {
          shiftId: shiftId,
          comment: comment
        };
}

function variables$4(param) {
  return Json.Encode.object_({
              hd: [
                "shiftId",
                Curry._1(CommonTypes_Shift.Id.encode, param.shift.id)
              ],
              tl: {
                hd: [
                  "comment",
                  param.comment
                ],
                tl: /* [] */0
              }
            });
}

function decode$4(param) {
  var match = param.updateShiftById;
  if (match !== undefined) {
    return Curry._2(Relude_Option.flatMap, WebTypes_Shift.tToR, match.shift);
  }
  
}

var Definition$4 = {
  Raw: Raw$4,
  query: query$4,
  parse: parse$4,
  serialize: serialize$4,
  serializeVariables: serializeVariables$4,
  makeVariables: makeVariables$4,
  variables: variables$4,
  decode: decode$4
};

var include$4 = Apollo.CreateMutation({
      Raw: Raw$4,
      query: query$4,
      variables: variables$4,
      parse: parse$4,
      decode: decode$4
    });

var CommentOnShift_graphqlMutationAST = include$4.graphqlMutationAST;

var CommentOnShift_mutate = include$4.mutate;

var CommentOnShift_mutateStoreError = include$4.mutateStoreError;

var CommentOnShift_mutateResult = include$4.mutateResult;

var CommentOnShift_mutateResultStore = include$4.mutateResultStore;

var CommentOnShift_mutateAsyncData = include$4.mutateAsyncData;

var CommentOnShift_mutateAsyncResult = include$4.mutateAsyncResult;

var CommentOnShift_mutateAsycResultApolloError = include$4.mutateAsycResultApolloError;

var CommentOnShift = {
  Definition: Definition$4,
  graphqlMutationAST: CommentOnShift_graphqlMutationAST,
  mutate: CommentOnShift_mutate,
  mutateStoreError: CommentOnShift_mutateStoreError,
  mutateResult: CommentOnShift_mutateResult,
  mutateResultStore: CommentOnShift_mutateResultStore,
  mutateAsyncData: CommentOnShift_mutateAsyncData,
  mutateAsyncResult: CommentOnShift_mutateAsyncResult,
  mutateAsycResultApolloError: CommentOnShift_mutateAsycResultApolloError
};

var Raw$5 = {};

var query$5 = "mutation reviewWorker($workerShiftId: BigInt!, $rating: Int!)  {\nbusinessReviewWorker(input: {workerShiftId: $workerShiftId, rating: $rating})  {\nshift  {\n...WebTypes_Shift   \n}\n\n}\n\n}\n" + WebTypes_Shift.query;

function parse$5(value) {
  var value$1 = value.businessReviewWorker;
  var tmp;
  if (value$1 == null) {
    tmp = undefined;
  } else {
    var value$2 = value$1.shift;
    tmp = {
      shift: WebTypes_Shift.verifyArgsAndParse("WebTypes_Shift", value$2)
    };
  }
  return {
          businessReviewWorker: tmp
        };
}

function serialize$5(value) {
  var value$1 = value.businessReviewWorker;
  var businessReviewWorker;
  if (value$1 !== undefined) {
    var value$2 = value$1.shift;
    var shift = WebTypes_Shift.serialize(value$2);
    businessReviewWorker = {
      shift: shift
    };
  } else {
    businessReviewWorker = null;
  }
  return {
          businessReviewWorker: businessReviewWorker
        };
}

function serializeVariables$5(inp) {
  return {
          workerShiftId: inp.workerShiftId,
          rating: inp.rating
        };
}

function makeVariables$5(workerShiftId, rating, param) {
  return {
          workerShiftId: workerShiftId,
          rating: rating
        };
}

function variables$5(param) {
  return Json.Encode.object_({
              hd: [
                "rating",
                CommonTypes_Rating.encode(param.rating)
              ],
              tl: {
                hd: [
                  "workerShiftId",
                  Curry._1(CommonTypes_WorkerShift.Id.encode, param.workerShiftId)
                ],
                tl: /* [] */0
              }
            });
}

function decode$5(param) {
  var match = param.businessReviewWorker;
  if (match !== undefined) {
    return WebTypes_Shift.tToR(match.shift);
  }
  
}

var Definition$5 = {
  Raw: Raw$5,
  query: query$5,
  parse: parse$5,
  serialize: serialize$5,
  serializeVariables: serializeVariables$5,
  makeVariables: makeVariables$5,
  variables: variables$5,
  decode: decode$5
};

var include$5 = Apollo.CreateMutation({
      Raw: Raw$5,
      query: query$5,
      variables: variables$5,
      parse: parse$5,
      decode: decode$5
    });

var ReviewWorker_graphqlMutationAST = include$5.graphqlMutationAST;

var ReviewWorker_mutate = include$5.mutate;

var ReviewWorker_mutateStoreError = include$5.mutateStoreError;

var ReviewWorker_mutateResult = include$5.mutateResult;

var ReviewWorker_mutateResultStore = include$5.mutateResultStore;

var ReviewWorker_mutateAsyncData = include$5.mutateAsyncData;

var ReviewWorker_mutateAsyncResult = include$5.mutateAsyncResult;

var ReviewWorker_mutateAsycResultApolloError = include$5.mutateAsycResultApolloError;

var ReviewWorker = {
  Definition: Definition$5,
  graphqlMutationAST: ReviewWorker_graphqlMutationAST,
  mutate: ReviewWorker_mutate,
  mutateStoreError: ReviewWorker_mutateStoreError,
  mutateResult: ReviewWorker_mutateResult,
  mutateResultStore: ReviewWorker_mutateResultStore,
  mutateAsyncData: ReviewWorker_mutateAsyncData,
  mutateAsyncResult: ReviewWorker_mutateAsyncResult,
  mutateAsycResultApolloError: ReviewWorker_mutateAsycResultApolloError
};

var Raw$6 = {};

var query$6 = "mutation businessPostShifts($accessoryIds: [Int]!, $address: String!, $attire: String, $copiedFrom: BigInt, $description: String!, $dressCode: DressCode!, $hourlyRate: Int!, $locationId: BigInt, $locationName: String!, $managerIsNew: Boolean!, $numberOfWorkers: Int!, $onsiteManagerFirstName: String!, $onsiteManagerLastName: String!, $onsiteManagerPhoneNumber: String!, $parkingCost: BusinessLocationParkingCost, $parkingInstructions: String!, $requestedWorkerIds: [BigInt]!, $shiftTimes: [ShiftTimeInput]!, $shiftTypeId: BigInt!, $tipsPayoutType: ShiftTipsPayoutType)  {\nbusinessPostShifts(input: {accessoryIds: $accessoryIds, address: $address, attire: $attire, copiedFrom: $copiedFrom, description: $description, dressCode: $dressCode, hourlyRate: $hourlyRate, locationId: $locationId, locationName: $locationName, managerIsNew: $managerIsNew, numberOfWorkers: $numberOfWorkers, onsiteManagerFirstName: $onsiteManagerFirstName, onsiteManagerLastName: $onsiteManagerLastName, onsiteManagerPhoneNumber: $onsiteManagerPhoneNumber, parkingCost: $parkingCost, parkingInstructions: $parkingInstructions, requestedWorkerIds: $requestedWorkerIds, shiftTimes: $shiftTimes, shiftTypeId: $shiftTypeId, tipsPayoutType: $tipsPayoutType})  {\nshifts  {\n...WebTypes_Shift   \n}\n\n}\n\n}\n" + WebTypes_Shift.query;

function parse$6(value) {
  var value$1 = value.businessPostShifts;
  var tmp;
  if (value$1 == null) {
    tmp = undefined;
  } else {
    var value$2 = value$1.shifts;
    tmp = {
      shifts: !(value$2 == null) ? value$2.map(function (value) {
              if (!(value == null)) {
                return WebTypes_Shift.verifyArgsAndParse("WebTypes_Shift", value);
              }
              
            }) : undefined
    };
  }
  return {
          businessPostShifts: tmp
        };
}

function serialize$6(value) {
  var value$1 = value.businessPostShifts;
  var businessPostShifts;
  if (value$1 !== undefined) {
    var value$2 = value$1.shifts;
    var shifts = value$2 !== undefined ? value$2.map(function (value) {
            if (value !== undefined) {
              return WebTypes_Shift.serialize(value);
            } else {
              return null;
            }
          }) : null;
    businessPostShifts = {
      shifts: shifts
    };
  } else {
    businessPostShifts = null;
  }
  return {
          businessPostShifts: businessPostShifts
        };
}

function serializeInputObjectShiftTimeInput$1(inp) {
  var a = inp.startDatetime;
  var a$1 = inp.endDatetime;
  return {
          startDatetime: a !== undefined ? Caml_option.valFromOption(a) : undefined,
          endDatetime: a$1 !== undefined ? Caml_option.valFromOption(a$1) : undefined
        };
}

function serializeVariables$6(inp) {
  var a = inp.accessoryIds;
  var a$1 = inp.attire;
  var a$2 = inp.copiedFrom;
  var a$3 = inp.dressCode;
  var a$4 = inp.locationId;
  var a$5 = inp.parkingCost;
  var a$6 = inp.requestedWorkerIds;
  var a$7 = inp.shiftTimes;
  var a$8 = inp.tipsPayoutType;
  return {
          accessoryIds: a.map(function (b) {
                if (b !== undefined) {
                  return b;
                }
                
              }),
          address: inp.address,
          attire: a$1 !== undefined ? a$1 : undefined,
          copiedFrom: a$2 !== undefined ? Caml_option.valFromOption(a$2) : undefined,
          description: inp.description,
          dressCode: a$3 === "BLACK_ON_BLACK" ? "BLACK_ON_BLACK" : (
              a$3 === "CUSTOM" ? "CUSTOM" : "WHITE_ON_BLACK"
            ),
          hourlyRate: inp.hourlyRate,
          locationId: a$4 !== undefined ? Caml_option.valFromOption(a$4) : undefined,
          locationName: inp.locationName,
          managerIsNew: inp.managerIsNew,
          numberOfWorkers: inp.numberOfWorkers,
          onsiteManagerFirstName: inp.onsiteManagerFirstName,
          onsiteManagerLastName: inp.onsiteManagerLastName,
          onsiteManagerPhoneNumber: inp.onsiteManagerPhoneNumber,
          parkingCost: a$5 !== undefined ? (
              a$5 === "FEE_REIMBURSED" ? "FEE_REIMBURSED" : (
                  a$5 === "PARKING_INFO_NOT_PROVIDED" ? "PARKING_INFO_NOT_PROVIDED" : (
                      a$5 === "FREE" ? "FREE" : "FEE_NOT_REIMBURSED"
                    )
                )
            ) : undefined,
          parkingInstructions: inp.parkingInstructions,
          requestedWorkerIds: a$6.map(function (b) {
                if (b !== undefined) {
                  return Caml_option.valFromOption(b);
                }
                
              }),
          shiftTimes: a$7.map(function (b) {
                if (b !== undefined) {
                  return serializeInputObjectShiftTimeInput$1(b);
                }
                
              }),
          shiftTypeId: inp.shiftTypeId,
          tipsPayoutType: a$8 !== undefined ? (
              a$8 === "TIPS_PAID_IN_CASH" ? "TIPS_PAID_IN_CASH" : (
                  a$8 === "NO_TIPS" ? "NO_TIPS" : "TIPS_PAID_BY_QWICK"
                )
            ) : undefined
        };
}

function makeVariables$6(accessoryIds, address, attire, copiedFrom, description, dressCode, hourlyRate, locationId, locationName, managerIsNew, numberOfWorkers, onsiteManagerFirstName, onsiteManagerLastName, onsiteManagerPhoneNumber, parkingCost, parkingInstructions, requestedWorkerIds, shiftTimes, shiftTypeId, tipsPayoutType, param) {
  return {
          accessoryIds: accessoryIds,
          address: address,
          attire: attire,
          copiedFrom: copiedFrom,
          description: description,
          dressCode: dressCode,
          hourlyRate: hourlyRate,
          locationId: locationId,
          locationName: locationName,
          managerIsNew: managerIsNew,
          numberOfWorkers: numberOfWorkers,
          onsiteManagerFirstName: onsiteManagerFirstName,
          onsiteManagerLastName: onsiteManagerLastName,
          onsiteManagerPhoneNumber: onsiteManagerPhoneNumber,
          parkingCost: parkingCost,
          parkingInstructions: parkingInstructions,
          requestedWorkerIds: requestedWorkerIds,
          shiftTimes: shiftTimes,
          shiftTypeId: shiftTypeId,
          tipsPayoutType: tipsPayoutType
        };
}

function makeInputObjectShiftTimeInput$1(startDatetime, endDatetime, param) {
  return {
          startDatetime: startDatetime,
          endDatetime: endDatetime
        };
}

function variables$6(param) {
  return Json.Encode.object_({
              hd: [
                "accessoryIds",
                Json.Encode.array(function (param) {
                        return Curry._1(CommonTypes_ShiftType_Accessory.Id.encode, param.id);
                      })(param.accessories)
              ],
              tl: {
                hd: [
                  "address",
                  param.address
                ],
                tl: {
                  hd: [
                    "attire",
                    Json.Encode.optional((function (prim) {
                            return prim;
                          }), param.attire)
                  ],
                  tl: {
                    hd: [
                      "copiedFrom",
                      Json.Encode.optional(CommonTypes_Shift.Id.encode, param.copiedFrom)
                    ],
                    tl: {
                      hd: [
                        "description",
                        param.description
                      ],
                      tl: {
                        hd: [
                          "dressCode",
                          CommonTypes_Shift_DressCode.encode(param.dressCode)
                        ],
                        tl: {
                          hd: [
                            "hourlyRate",
                            Relude_Float.roundAsInt(param.hourlyRate * 100.0)
                          ],
                          tl: {
                            hd: [
                              "locationId",
                              Json.Encode.optional(CommonTypes_Business_Location.Id.encode, param.locationId)
                            ],
                            tl: {
                              hd: [
                                "locationName",
                                param.locationName
                              ],
                              tl: {
                                hd: [
                                  "managerIsNew",
                                  param.onsiteManagerIsNew
                                ],
                                tl: {
                                  hd: [
                                    "numberOfWorkers",
                                    param.numberOfWorkers
                                  ],
                                  tl: {
                                    hd: [
                                      "onsiteManagerFirstName",
                                      param.onsiteManagerFirstName
                                    ],
                                    tl: {
                                      hd: [
                                        "onsiteManagerLastName",
                                        param.onsiteManagerLastName
                                      ],
                                      tl: {
                                        hd: [
                                          "onsiteManagerPhoneNumber",
                                          CommonTypes_LongPhoneNumber.encode(param.onsiteManagerPhoneNumber)
                                        ],
                                        tl: {
                                          hd: [
                                            "parkingCost",
                                            CommonTypes_Business_Location_ParkingCost.encode(param.parkingCost)
                                          ],
                                          tl: {
                                            hd: [
                                              "parkingInstructions",
                                              param.parkingInstructions
                                            ],
                                            tl: {
                                              hd: [
                                                "requestedWorkerIds",
                                                Json.Encode.array(function (param) {
                                                        return Curry._1(CommonTypes_Worker_Id.encode, param.workerId);
                                                      })(Relude_Set.toArray(param.requestedWorkers))
                                              ],
                                              tl: {
                                                hd: [
                                                  "shiftTimes",
                                                  Json.Encode.array(function (param) {
                                                          return Json.Encode.object_({
                                                                      hd: [
                                                                        "startDatetime",
                                                                        Json.Encode.date(param.startDatetime)
                                                                      ],
                                                                      tl: {
                                                                        hd: [
                                                                          "endDatetime",
                                                                          Json.Encode.date(param.endDatetime)
                                                                        ],
                                                                        tl: /* [] */0
                                                                      }
                                                                    });
                                                        })(param.dates)
                                                ],
                                                tl: {
                                                  hd: [
                                                    "shiftTypeId",
                                                    Curry._1(CommonTypes_ShiftType.Id.encode, param.shiftType.id)
                                                  ],
                                                  tl: {
                                                    hd: [
                                                      "tipsPayoutType",
                                                      CommonTypes_Shift_TipsPayoutType.encode(param.tipsPayoutType)
                                                    ],
                                                    tl: /* [] */0
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            });
}

function decode$6(param) {
  var match = param.businessPostShifts;
  if (match === undefined) {
    return ;
  }
  var partial_arg = Curry._1(Relude_Option.flatMap, WebTypes_Shift.tToR);
  return Relude_Option.map((function (param) {
                return Relude_Array.mapOption(partial_arg, param);
              }), match.shifts);
}

var Definition$6 = {
  Raw: Raw$6,
  query: query$6,
  parse: parse$6,
  serialize: serialize$6,
  serializeVariables: serializeVariables$6,
  serializeInputObjectShiftTimeInput: serializeInputObjectShiftTimeInput$1,
  makeVariables: makeVariables$6,
  makeInputObjectShiftTimeInput: makeInputObjectShiftTimeInput$1,
  variables: variables$6,
  decode: decode$6
};

var include$6 = Apollo.CreateMutation({
      Raw: Raw$6,
      query: query$6,
      variables: variables$6,
      parse: parse$6,
      decode: decode$6
    });

var PostShifts_graphqlMutationAST = include$6.graphqlMutationAST;

var PostShifts_mutate = include$6.mutate;

var PostShifts_mutateStoreError = include$6.mutateStoreError;

var PostShifts_mutateResult = include$6.mutateResult;

var PostShifts_mutateResultStore = include$6.mutateResultStore;

var PostShifts_mutateAsyncData = include$6.mutateAsyncData;

var PostShifts_mutateAsyncResult = include$6.mutateAsyncResult;

var PostShifts_mutateAsycResultApolloError = include$6.mutateAsycResultApolloError;

var PostShifts = {
  Definition: Definition$6,
  graphqlMutationAST: PostShifts_graphqlMutationAST,
  mutate: PostShifts_mutate,
  mutateStoreError: PostShifts_mutateStoreError,
  mutateResult: PostShifts_mutateResult,
  mutateResultStore: PostShifts_mutateResultStore,
  mutateAsyncData: PostShifts_mutateAsyncData,
  mutateAsyncResult: PostShifts_mutateAsyncResult,
  mutateAsycResultApolloError: PostShifts_mutateAsycResultApolloError
};

var Raw$7 = {};

var query$7 = "query ($id: BigInt!)  {\nshiftById(id: $id)  {\n...WebTypes_Shift   \n}\n\n}\n" + WebTypes_Shift.query;

function parse$7(value) {
  var value$1 = value.shiftById;
  return {
          shiftById: !(value$1 == null) ? WebTypes_Shift.verifyArgsAndParse("WebTypes_Shift", value$1) : undefined
        };
}

function serialize$7(value) {
  var value$1 = value.shiftById;
  var shiftById = value$1 !== undefined ? WebTypes_Shift.serialize(value$1) : null;
  return {
          shiftById: shiftById
        };
}

function serializeVariables$7(inp) {
  return {
          id: inp.id
        };
}

function makeVariables$7(id, param) {
  return {
          id: id
        };
}

function variables$7(id) {
  return Json.Encode.object_({
              hd: [
                "id",
                Curry._1(CommonTypes_Shift.Id.encode, id)
              ],
              tl: /* [] */0
            });
}

function decode$7(param) {
  return Curry._2(Relude_Option.flatMap, WebTypes_Shift.tToR, param.shiftById);
}

var Definition$7 = {
  Raw: Raw$7,
  query: query$7,
  parse: parse$7,
  serialize: serialize$7,
  serializeVariables: serializeVariables$7,
  makeVariables: makeVariables$7,
  variables: variables$7,
  decode: decode$7
};

var include$7 = Apollo.CreateQuery({
      Raw: Raw$7,
      query: query$7,
      variables: variables$7,
      parse: parse$7,
      decode: decode$7
    });

var GetShiftById_graphqlQueryAST = include$7.graphqlQueryAST;

var GetShiftById_query = include$7.query;

var GetShiftById_queryStoreError = include$7.queryStoreError;

var GetShiftById_queryResult = include$7.queryResult;

var GetShiftById_queryAsyncData = include$7.queryAsyncData;

var GetShiftById_queryAsyncDataStoreError = include$7.queryAsyncDataStoreError;

var GetShiftById_queryAsyncResult = include$7.queryAsyncResult;

var GetShiftById = {
  Definition: Definition$7,
  graphqlQueryAST: GetShiftById_graphqlQueryAST,
  query: GetShiftById_query,
  queryStoreError: GetShiftById_queryStoreError,
  queryResult: GetShiftById_queryResult,
  queryAsyncData: GetShiftById_queryAsyncData,
  queryAsyncDataStoreError: GetShiftById_queryAsyncDataStoreError,
  queryAsyncResult: GetShiftById_queryAsyncResult
};

var Raw$8 = {};

var query$8 = "query   {\ncurrentUser  {\nid  \nbusiness  {\nid  \nrequestableWorkers  {\nnodes  {\n...CommonTypes_Business_RequestableWorker   \n}\n\n}\n\n}\n\nmanagedBusiness  {\nid  \nrequestableWorkers  {\nnodes  {\n...CommonTypes_Business_RequestableWorker   \n}\n\n}\n\n}\n\n}\n\n}\n" + CommonTypes_Business_RequestableWorker.query;

function parse$8(value) {
  var value$1 = value.currentUser;
  var tmp;
  if (value$1 == null) {
    tmp = undefined;
  } else {
    var value$2 = value$1.business;
    var tmp$1;
    if (value$2 == null) {
      tmp$1 = undefined;
    } else {
      var value$3 = value$2.requestableWorkers;
      var value$4 = value$3.nodes;
      tmp$1 = {
        id: value$2.id,
        requestableWorkers: {
          nodes: value$4.map(function (value) {
                if (!(value == null)) {
                  return CommonTypes_Business_RequestableWorker.verifyArgsAndParse("CommonTypes_Business_RequestableWorker", value);
                }
                
              })
        }
      };
    }
    var value$5 = value$1.managedBusiness;
    var tmp$2;
    if (value$5 == null) {
      tmp$2 = undefined;
    } else {
      var value$6 = value$5.requestableWorkers;
      var value$7 = value$6.nodes;
      tmp$2 = {
        id: value$5.id,
        requestableWorkers: {
          nodes: value$7.map(function (value) {
                if (!(value == null)) {
                  return CommonTypes_Business_RequestableWorker.verifyArgsAndParse("CommonTypes_Business_RequestableWorker", value);
                }
                
              })
        }
      };
    }
    tmp = {
      id: value$1.id,
      business: tmp$1,
      managedBusiness: tmp$2
    };
  }
  return {
          currentUser: tmp
        };
}

function serialize$8(value) {
  var value$1 = value.currentUser;
  var currentUser;
  if (value$1 !== undefined) {
    var value$2 = value$1.managedBusiness;
    var managedBusiness;
    if (value$2 !== undefined) {
      var value$3 = value$2.requestableWorkers;
      var value$4 = value$3.nodes;
      var nodes = value$4.map(function (value) {
            if (value !== undefined) {
              return CommonTypes_Business_RequestableWorker.serialize(value);
            } else {
              return null;
            }
          });
      var requestableWorkers = {
        nodes: nodes
      };
      var value$5 = value$2.id;
      managedBusiness = {
        id: value$5,
        requestableWorkers: requestableWorkers
      };
    } else {
      managedBusiness = null;
    }
    var value$6 = value$1.business;
    var business;
    if (value$6 !== undefined) {
      var value$7 = value$6.requestableWorkers;
      var value$8 = value$7.nodes;
      var nodes$1 = value$8.map(function (value) {
            if (value !== undefined) {
              return CommonTypes_Business_RequestableWorker.serialize(value);
            } else {
              return null;
            }
          });
      var requestableWorkers$1 = {
        nodes: nodes$1
      };
      var value$9 = value$6.id;
      business = {
        id: value$9,
        requestableWorkers: requestableWorkers$1
      };
    } else {
      business = null;
    }
    var value$10 = value$1.id;
    currentUser = {
      id: value$10,
      business: business,
      managedBusiness: managedBusiness
    };
  } else {
    currentUser = null;
  }
  return {
          currentUser: currentUser
        };
}

function serializeVariables$8(param) {
  
}

function makeVariables$8(param) {
  
}

function makeDefaultVariables$1(param) {
  
}

function variables$8(param) {
  return Json.Encode.object_(/* [] */0);
}

function decode$8(param) {
  var nodes;
  var match = param.currentUser;
  if (match === undefined) {
    return ;
  }
  var match$1 = match.business;
  if (match$1 !== undefined) {
    nodes = match$1.requestableWorkers.nodes;
  } else {
    var match$2 = match.managedBusiness;
    if (match$2 === undefined) {
      return ;
    }
    nodes = match$2.requestableWorkers.nodes;
  }
  return Relude_Option.pure(Curry._1(CommonTypes_Business_RequestableWorker.$$Set.fromArray, Relude_Array.mapOption(Curry._1(Relude_Option.flatMap, CommonTypes_Business_RequestableWorker.tToR), nodes)));
}

var Definition$8 = {
  Raw: Raw$8,
  query: query$8,
  parse: parse$8,
  serialize: serialize$8,
  serializeVariables: serializeVariables$8,
  makeVariables: makeVariables$8,
  makeDefaultVariables: makeDefaultVariables$1,
  variables: variables$8,
  decode: decode$8
};

var include$8 = Apollo.CreateQuery({
      Raw: Raw$8,
      query: query$8,
      variables: variables$8,
      parse: parse$8,
      decode: decode$8
    });

var GetRequestedWorkers_graphqlQueryAST = include$8.graphqlQueryAST;

var GetRequestedWorkers_query = include$8.query;

var GetRequestedWorkers_queryStoreError = include$8.queryStoreError;

var GetRequestedWorkers_queryResult = include$8.queryResult;

var GetRequestedWorkers_queryAsyncData = include$8.queryAsyncData;

var GetRequestedWorkers_queryAsyncDataStoreError = include$8.queryAsyncDataStoreError;

var GetRequestedWorkers_queryAsyncResult = include$8.queryAsyncResult;

var GetRequestedWorkers = {
  Definition: Definition$8,
  graphqlQueryAST: GetRequestedWorkers_graphqlQueryAST,
  query: GetRequestedWorkers_query,
  queryStoreError: GetRequestedWorkers_queryStoreError,
  queryResult: GetRequestedWorkers_queryResult,
  queryAsyncData: GetRequestedWorkers_queryAsyncData,
  queryAsyncDataStoreError: GetRequestedWorkers_queryAsyncDataStoreError,
  queryAsyncResult: GetRequestedWorkers_queryAsyncResult
};

var Raw$9 = {};

var query$9 = "query ($after: Cursor, $first: Int, $last: Int, $before: Cursor, $cutoff: Datetime!)  {\ncurrentUser  {\nid  \nbusiness  {\nid  \nshifts(after: $after, first: $first, last: $last, before: $before, orderBy: [START_DATETIME_ASC], filter: {and: [{cancelledAt: {isNull: true}}, {endDatetime: {greaterThanOrEqualTo: $cutoff}}]})  {\npageInfo  {\n...Paging_PageMarkers   \n}\n\nnodes  {\n...WebTypes_Shift   \n}\n\n}\n\n}\n\n}\n\n}\n" + Paging_PageMarkers.query + WebTypes_Shift.query;

function parse$9(value) {
  var value$1 = value.currentUser;
  var tmp;
  if (value$1 == null) {
    tmp = undefined;
  } else {
    var value$2 = value$1.business;
    var tmp$1;
    if (value$2 == null) {
      tmp$1 = undefined;
    } else {
      var value$3 = value$2.shifts;
      var value$4 = value$3.pageInfo;
      var value$5 = value$3.nodes;
      tmp$1 = {
        id: value$2.id,
        shifts: {
          pageInfo: Paging_PageMarkers.verifyArgsAndParse("Paging_PageMarkers", value$4),
          nodes: value$5.map(function (value) {
                if (!(value == null)) {
                  return WebTypes_Shift.verifyArgsAndParse("WebTypes_Shift", value);
                }
                
              })
        }
      };
    }
    tmp = {
      id: value$1.id,
      business: tmp$1
    };
  }
  return {
          currentUser: tmp
        };
}

function serialize$9(value) {
  var value$1 = value.currentUser;
  var currentUser;
  if (value$1 !== undefined) {
    var value$2 = value$1.business;
    var business;
    if (value$2 !== undefined) {
      var value$3 = value$2.shifts;
      var value$4 = value$3.nodes;
      var nodes = value$4.map(function (value) {
            if (value !== undefined) {
              return WebTypes_Shift.serialize(value);
            } else {
              return null;
            }
          });
      var value$5 = value$3.pageInfo;
      var pageInfo = Paging_PageMarkers.serialize(value$5);
      var shifts = {
        pageInfo: pageInfo,
        nodes: nodes
      };
      var value$6 = value$2.id;
      business = {
        id: value$6,
        shifts: shifts
      };
    } else {
      business = null;
    }
    var value$7 = value$1.id;
    currentUser = {
      id: value$7,
      business: business
    };
  } else {
    currentUser = null;
  }
  return {
          currentUser: currentUser
        };
}

function serializeVariables$9(inp) {
  var a = inp.after;
  var a$1 = inp.first;
  var a$2 = inp.last;
  var a$3 = inp.before;
  return {
          after: a !== undefined ? Caml_option.valFromOption(a) : undefined,
          first: a$1 !== undefined ? a$1 : undefined,
          last: a$2 !== undefined ? a$2 : undefined,
          before: a$3 !== undefined ? Caml_option.valFromOption(a$3) : undefined,
          cutoff: inp.cutoff
        };
}

function makeVariables$9(after, first, last, before, cutoff, param) {
  return {
          after: after,
          first: first,
          last: last,
          before: before,
          cutoff: cutoff
        };
}

function variables$9(param) {
  return Json.Encode.object_(Relude_List.concat(Relude_Option.fold({
                      hd: [
                        "first",
                        20
                      ],
                      tl: /* [] */0
                    }, Paging.CursorDirection.encodeForObject, param.pageInfo), {
                  hd: [
                    "cutoff",
                    Json.Encode.date(param.cutoff)
                  ],
                  tl: /* [] */0
                }));
}

function decode$9(param) {
  var match = param.currentUser;
  if (match === undefined) {
    return ;
  }
  var match$1 = match.business;
  if (match$1 === undefined) {
    return ;
  }
  var match$2 = match$1.shifts;
  return Relude_Option.pure({
              pageMarkers: Paging_PageMarkers.tToR(match$2.pageInfo),
              data: Curry._1(WebTypes_Shift.$$Set.fromArray, Relude_Array.mapOption(Curry._1(Relude_Option.flatMap, WebTypes_Shift.tToR), match$2.nodes))
            });
}

var Definition$9 = {
  Raw: Raw$9,
  query: query$9,
  parse: parse$9,
  serialize: serialize$9,
  serializeVariables: serializeVariables$9,
  makeVariables: makeVariables$9,
  variables: variables$9,
  decode: decode$9
};

var include$9 = Apollo.CreateQuery({
      Raw: Raw$9,
      query: query$9,
      variables: variables$9,
      parse: parse$9,
      decode: decode$9
    });

var GetUpcomingShiftsForBusiness_graphqlQueryAST = include$9.graphqlQueryAST;

var GetUpcomingShiftsForBusiness_query = include$9.query;

var GetUpcomingShiftsForBusiness_queryStoreError = include$9.queryStoreError;

var GetUpcomingShiftsForBusiness_queryResult = include$9.queryResult;

var GetUpcomingShiftsForBusiness_queryAsyncData = include$9.queryAsyncData;

var GetUpcomingShiftsForBusiness_queryAsyncDataStoreError = include$9.queryAsyncDataStoreError;

var GetUpcomingShiftsForBusiness_queryAsyncResult = include$9.queryAsyncResult;

var GetUpcomingShiftsForBusiness = {
  Definition: Definition$9,
  graphqlQueryAST: GetUpcomingShiftsForBusiness_graphqlQueryAST,
  query: GetUpcomingShiftsForBusiness_query,
  queryStoreError: GetUpcomingShiftsForBusiness_queryStoreError,
  queryResult: GetUpcomingShiftsForBusiness_queryResult,
  queryAsyncData: GetUpcomingShiftsForBusiness_queryAsyncData,
  queryAsyncDataStoreError: GetUpcomingShiftsForBusiness_queryAsyncDataStoreError,
  queryAsyncResult: GetUpcomingShiftsForBusiness_queryAsyncResult
};

var Raw$10 = {};

var query$10 = "query ($after: Cursor, $first: Int, $last: Int, $before: Cursor, $cutoff: Datetime!)  {\ncurrentUser  {\nid  \nbusiness  {\nid  \nshifts(after: $after, first: $first, last: $last, before: $before, orderBy: [START_DATETIME_DESC], filter: {or: [{cancelledAt: {isNull: false}}, {endDatetime: {lessThan: $cutoff}}]})  {\npageInfo  {\n...Paging_PageMarkers   \n}\n\nnodes  {\n...WebTypes_Shift   \n}\n\n}\n\n}\n\n}\n\n}\n" + Paging_PageMarkers.query + WebTypes_Shift.query;

function parse$10(value) {
  var value$1 = value.currentUser;
  var tmp;
  if (value$1 == null) {
    tmp = undefined;
  } else {
    var value$2 = value$1.business;
    var tmp$1;
    if (value$2 == null) {
      tmp$1 = undefined;
    } else {
      var value$3 = value$2.shifts;
      var value$4 = value$3.pageInfo;
      var value$5 = value$3.nodes;
      tmp$1 = {
        id: value$2.id,
        shifts: {
          pageInfo: Paging_PageMarkers.verifyArgsAndParse("Paging_PageMarkers", value$4),
          nodes: value$5.map(function (value) {
                if (!(value == null)) {
                  return WebTypes_Shift.verifyArgsAndParse("WebTypes_Shift", value);
                }
                
              })
        }
      };
    }
    tmp = {
      id: value$1.id,
      business: tmp$1
    };
  }
  return {
          currentUser: tmp
        };
}

function serialize$10(value) {
  var value$1 = value.currentUser;
  var currentUser;
  if (value$1 !== undefined) {
    var value$2 = value$1.business;
    var business;
    if (value$2 !== undefined) {
      var value$3 = value$2.shifts;
      var value$4 = value$3.nodes;
      var nodes = value$4.map(function (value) {
            if (value !== undefined) {
              return WebTypes_Shift.serialize(value);
            } else {
              return null;
            }
          });
      var value$5 = value$3.pageInfo;
      var pageInfo = Paging_PageMarkers.serialize(value$5);
      var shifts = {
        pageInfo: pageInfo,
        nodes: nodes
      };
      var value$6 = value$2.id;
      business = {
        id: value$6,
        shifts: shifts
      };
    } else {
      business = null;
    }
    var value$7 = value$1.id;
    currentUser = {
      id: value$7,
      business: business
    };
  } else {
    currentUser = null;
  }
  return {
          currentUser: currentUser
        };
}

function serializeVariables$10(inp) {
  var a = inp.after;
  var a$1 = inp.first;
  var a$2 = inp.last;
  var a$3 = inp.before;
  return {
          after: a !== undefined ? Caml_option.valFromOption(a) : undefined,
          first: a$1 !== undefined ? a$1 : undefined,
          last: a$2 !== undefined ? a$2 : undefined,
          before: a$3 !== undefined ? Caml_option.valFromOption(a$3) : undefined,
          cutoff: inp.cutoff
        };
}

function makeVariables$10(after, first, last, before, cutoff, param) {
  return {
          after: after,
          first: first,
          last: last,
          before: before,
          cutoff: cutoff
        };
}

function variables$10(param) {
  return Json.Encode.object_(Relude_List.concat(Relude_Option.fold({
                      hd: [
                        "first",
                        20
                      ],
                      tl: /* [] */0
                    }, Paging.CursorDirection.encodeForObject, param.pageInfo), {
                  hd: [
                    "cutoff",
                    Json.Encode.date(param.cutoff)
                  ],
                  tl: /* [] */0
                }));
}

function decode$10(param) {
  var match = param.currentUser;
  if (match === undefined) {
    return ;
  }
  var match$1 = match.business;
  if (match$1 === undefined) {
    return ;
  }
  var match$2 = match$1.shifts;
  return Relude_Option.pure({
              pageMarkers: Paging_PageMarkers.tToR(match$2.pageInfo),
              data: Curry._1(WebTypes_Shift.$$Set.fromArray, Relude_Array.mapOption(Curry._1(Relude_Option.flatMap, WebTypes_Shift.tToR), match$2.nodes))
            });
}

var Definition$10 = {
  Raw: Raw$10,
  query: query$10,
  parse: parse$10,
  serialize: serialize$10,
  serializeVariables: serializeVariables$10,
  makeVariables: makeVariables$10,
  variables: variables$10,
  decode: decode$10
};

var include$10 = Apollo.CreateQuery({
      Raw: Raw$10,
      query: query$10,
      variables: variables$10,
      parse: parse$10,
      decode: decode$10
    });

var GetPastShiftsForBusiness_graphqlQueryAST = include$10.graphqlQueryAST;

var GetPastShiftsForBusiness_query = include$10.query;

var GetPastShiftsForBusiness_queryStoreError = include$10.queryStoreError;

var GetPastShiftsForBusiness_queryResult = include$10.queryResult;

var GetPastShiftsForBusiness_queryAsyncData = include$10.queryAsyncData;

var GetPastShiftsForBusiness_queryAsyncDataStoreError = include$10.queryAsyncDataStoreError;

var GetPastShiftsForBusiness_queryAsyncResult = include$10.queryAsyncResult;

var GetPastShiftsForBusiness = {
  Definition: Definition$10,
  graphqlQueryAST: GetPastShiftsForBusiness_graphqlQueryAST,
  query: GetPastShiftsForBusiness_query,
  queryStoreError: GetPastShiftsForBusiness_queryStoreError,
  queryResult: GetPastShiftsForBusiness_queryResult,
  queryAsyncData: GetPastShiftsForBusiness_queryAsyncData,
  queryAsyncDataStoreError: GetPastShiftsForBusiness_queryAsyncDataStoreError,
  queryAsyncResult: GetPastShiftsForBusiness_queryAsyncResult
};

var Raw$11 = {};

var query$11 = "mutation ($shiftId: BigInt!)  {\nbusinessCancelShift(input: {shiftId: $shiftId})  {\nclientMutationId  \nshift  {\n...WebTypes_Shift   \n}\n\n}\n\n}\n" + WebTypes_Shift.query;

function parse$11(value) {
  var value$1 = value.businessCancelShift;
  var tmp;
  if (value$1 == null) {
    tmp = undefined;
  } else {
    var value$2 = value$1.clientMutationId;
    var value$3 = value$1.shift;
    tmp = {
      clientMutationId: !(value$2 == null) ? value$2 : undefined,
      shift: !(value$3 == null) ? WebTypes_Shift.verifyArgsAndParse("WebTypes_Shift", value$3) : undefined
    };
  }
  return {
          businessCancelShift: tmp
        };
}

function serialize$11(value) {
  var value$1 = value.businessCancelShift;
  var businessCancelShift;
  if (value$1 !== undefined) {
    var value$2 = value$1.shift;
    var shift = value$2 !== undefined ? WebTypes_Shift.serialize(value$2) : null;
    var value$3 = value$1.clientMutationId;
    var clientMutationId = value$3 !== undefined ? value$3 : null;
    businessCancelShift = {
      clientMutationId: clientMutationId,
      shift: shift
    };
  } else {
    businessCancelShift = null;
  }
  return {
          businessCancelShift: businessCancelShift
        };
}

function serializeVariables$11(inp) {
  return {
          shiftId: inp.shiftId
        };
}

function makeVariables$11(shiftId, param) {
  return {
          shiftId: shiftId
        };
}

function variables$11(param) {
  return Json.Encode.object_({
              hd: [
                "shiftId",
                Curry._1(CommonTypes_Shift.Id.encode, param.id)
              ],
              tl: /* [] */0
            });
}

function decode$11(param) {
  var match = param.businessCancelShift;
  if (match !== undefined) {
    return Curry._2(Relude_Option.flatMap, WebTypes_Shift.tToR, match.shift);
  }
  
}

var Definition$11 = {
  Raw: Raw$11,
  query: query$11,
  parse: parse$11,
  serialize: serialize$11,
  serializeVariables: serializeVariables$11,
  makeVariables: makeVariables$11,
  variables: variables$11,
  decode: decode$11
};

var include$11 = Apollo.CreateMutation({
      Raw: Raw$11,
      query: query$11,
      variables: variables$11,
      parse: parse$11,
      decode: decode$11
    });

var CancelShift_graphqlMutationAST = include$11.graphqlMutationAST;

var CancelShift_mutate = include$11.mutate;

var CancelShift_mutateStoreError = include$11.mutateStoreError;

var CancelShift_mutateResult = include$11.mutateResult;

var CancelShift_mutateResultStore = include$11.mutateResultStore;

var CancelShift_mutateAsyncData = include$11.mutateAsyncData;

var CancelShift_mutateAsyncResult = include$11.mutateAsyncResult;

var CancelShift_mutateAsycResultApolloError = include$11.mutateAsycResultApolloError;

var CancelShift = {
  Definition: Definition$11,
  graphqlMutationAST: CancelShift_graphqlMutationAST,
  mutate: CancelShift_mutate,
  mutateStoreError: CancelShift_mutateStoreError,
  mutateResult: CancelShift_mutateResult,
  mutateResultStore: CancelShift_mutateResultStore,
  mutateAsyncData: CancelShift_mutateAsyncData,
  mutateAsyncResult: CancelShift_mutateAsyncResult,
  mutateAsycResultApolloError: CancelShift_mutateAsycResultApolloError
};

var Raw$12 = {};

var query$12 = "mutation currentBusinessAddZipcodeLaunchInterest($fullAddress: String!, $zipcode: ZipCode!)  {\ncurrentBusinessAddZipcodeLaunchInterest(input: {fullAddress: $fullAddress, zipcode: $zipcode})  {\nclientMutationId  \n}\n\n}\n";

function parse$12(value) {
  var value$1 = value.currentBusinessAddZipcodeLaunchInterest;
  var tmp;
  if (value$1 == null) {
    tmp = undefined;
  } else {
    var value$2 = value$1.clientMutationId;
    tmp = {
      clientMutationId: !(value$2 == null) ? value$2 : undefined
    };
  }
  return {
          currentBusinessAddZipcodeLaunchInterest: tmp
        };
}

function serialize$12(value) {
  var value$1 = value.currentBusinessAddZipcodeLaunchInterest;
  var currentBusinessAddZipcodeLaunchInterest;
  if (value$1 !== undefined) {
    var value$2 = value$1.clientMutationId;
    var clientMutationId = value$2 !== undefined ? value$2 : null;
    currentBusinessAddZipcodeLaunchInterest = {
      clientMutationId: clientMutationId
    };
  } else {
    currentBusinessAddZipcodeLaunchInterest = null;
  }
  return {
          currentBusinessAddZipcodeLaunchInterest: currentBusinessAddZipcodeLaunchInterest
        };
}

function serializeVariables$12(inp) {
  return {
          fullAddress: inp.fullAddress,
          zipcode: inp.zipcode
        };
}

function makeVariables$12(fullAddress, zipcode, param) {
  return {
          fullAddress: fullAddress,
          zipcode: zipcode
        };
}

function variables$12(param) {
  return Json.Encode.object_({
              hd: [
                "fullAddress",
                param.formattedAddress
              ],
              tl: {
                hd: [
                  "zipcode",
                  Curry._1(CommonTypes_ZipCode.encode, param.zipcode)
                ],
                tl: /* [] */0
              }
            });
}

function decode$12(param) {
  return Relude_Option.pure(undefined);
}

var Definition$12 = {
  Raw: Raw$12,
  query: query$12,
  parse: parse$12,
  serialize: serialize$12,
  serializeVariables: serializeVariables$12,
  makeVariables: makeVariables$12,
  variables: variables$12,
  decode: decode$12
};

var include$12 = Apollo.CreateMutation({
      Raw: Raw$12,
      query: query$12,
      variables: variables$12,
      parse: parse$12,
      decode: decode$12
    });

var AddNotLaunchedZipcodeInterest_graphqlMutationAST = include$12.graphqlMutationAST;

var AddNotLaunchedZipcodeInterest_mutate = include$12.mutate;

var AddNotLaunchedZipcodeInterest_mutateStoreError = include$12.mutateStoreError;

var AddNotLaunchedZipcodeInterest_mutateResult = include$12.mutateResult;

var AddNotLaunchedZipcodeInterest_mutateResultStore = include$12.mutateResultStore;

var AddNotLaunchedZipcodeInterest_mutateAsyncData = include$12.mutateAsyncData;

var AddNotLaunchedZipcodeInterest_mutateAsyncResult = include$12.mutateAsyncResult;

var AddNotLaunchedZipcodeInterest_mutateAsycResultApolloError = include$12.mutateAsycResultApolloError;

var AddNotLaunchedZipcodeInterest = {
  Definition: Definition$12,
  graphqlMutationAST: AddNotLaunchedZipcodeInterest_graphqlMutationAST,
  mutate: AddNotLaunchedZipcodeInterest_mutate,
  mutateStoreError: AddNotLaunchedZipcodeInterest_mutateStoreError,
  mutateResult: AddNotLaunchedZipcodeInterest_mutateResult,
  mutateResultStore: AddNotLaunchedZipcodeInterest_mutateResultStore,
  mutateAsyncData: AddNotLaunchedZipcodeInterest_mutateAsyncData,
  mutateAsyncResult: AddNotLaunchedZipcodeInterest_mutateAsyncResult,
  mutateAsycResultApolloError: AddNotLaunchedZipcodeInterest_mutateAsycResultApolloError
};

exports.GetShiftTypes = GetShiftTypes;
exports.GeocodeAddress = GeocodeAddress;
exports.EditShift = EditShift;
exports.GetShiftRateStats = GetShiftRateStats;
exports.CommentOnShift = CommentOnShift;
exports.ReviewWorker = ReviewWorker;
exports.PostShifts = PostShifts;
exports.GetShiftById = GetShiftById;
exports.GetRequestedWorkers = GetRequestedWorkers;
exports.GetUpcomingShiftsForBusiness = GetUpcomingShiftsForBusiness;
exports.GetPastShiftsForBusiness = GetPastShiftsForBusiness;
exports.CancelShift = CancelShift;
exports.AddNotLaunchedZipcodeInterest = AddNotLaunchedZipcodeInterest;
/* include Not a pure module */
